import type { ReactNode } from 'react';

/** Props do FormSection */
export interface FormSectionProps {
  /** Rótulo da seção (exibido em maiúsculas) */
  readonly title: string;
  /** Conteúdo da seção */
  readonly children: ReactNode;
}

/**
 * Seção de formulário com rótulo em maiúsculas e uma divisória à direita,
 * usada para agrupar os campos do formulário de questão (Conteúdo, Classificação,
 * Exibição e regras).
 */
export function FormSection({ title, children }: FormSectionProps) {
  return (
    <section className="flex flex-col gap-xs">
      <div className="flex items-center gap-nano">
        <span className="uppercase tracking-wide text-ctx-content-placeholder ts-caption-xxs">
          {title}
        </span>
        <div className="flex-1 border-t-hairline border-ctx-layout-border" />
      </div>
      <div className="flex flex-col gap-xxs">{children}</div>
    </section>
  );
}
